import {
  Box,
  MenuCheckboxItem,
  MenuGroup,
  MenuGroupLabel,
  MenuSeparator,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

import { QuickCustomRange } from "./quick-custom-range";
import type { QuickFilterOption } from "./quick-filter-options";
import { QuickOptionFace } from "./quick-option-face";

type QuickDateSubmenuProps = Omittable<{
  /** The named windows, single-select — picking one replaces the last, and
   *  picking the applied one clears the filter. */
  options: QuickFilterOption[];
  value: unknown;
  onChange: (value: unknown) => void;
}>;

/**
 * The date-window submenu: the named presets, then the two-date range the
 * presets cannot enumerate (`QuickCustomRange`).
 *
 * The custom range lives here rather than behind the shared
 * `DateRangePresetPicker` because that control IS a `Select` — it owns a
 * trigger and a popup of its own, and a second popup opening out of a submenu
 * row is a third floating layer for one date. The value it writes is the same
 * `DatePresetValue` either way, and `DATE_PRESETS` is still the one list of
 * windows; only the chrome differs. The picker stays the control on every
 * surface that wants a select (the dashboard toolbars).
 */
export function QuickDateSubmenu({
  options,
  value,
  onChange,
}: QuickDateSubmenuProps) {
  return (
    <>
      {options.map((option) => (
        <MenuCheckboxItem
          key={option.key}
          checked={option.selected(value)}
          onCheckedChange={() => onChange(option.toggle(value))}
          variant="trailing"
        >
          <QuickOptionFace option={option} />
        </MenuCheckboxItem>
      ))}
      <MenuSeparator />
      {/* The label needs its own group: a group label reads the nearest
          group's context, and the nearest one otherwise is whatever group the
          ROW sits in, whose accessible name this would then overwrite. */}
      <MenuGroup>
        <MenuGroupLabel>Custom range</MenuGroupLabel>
        <Box paddingX="2xs" paddingBottom="2xs">
          <QuickCustomRange value={value} onChange={onChange} />
        </Box>
      </MenuGroup>
    </>
  );
}
